module.exports = __webpack_public_path__ + "img/6.4fc29b86.png";